import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const NotFoundPage = (props) => {
  const message = props.message ? props.message : "";
  return (
    <div>
      <h4>
        {`404 Page Not Found${message}`}
      </h4>
      <Link to="/"> Go back to homepage </Link>
    </div>
  );
};

NotFoundPage.defaultProps = {
  message:"",
};

NotFoundPage.propTypes = {
  message: PropTypes.string,
};

export default NotFoundPage;
